import Vue from 'vue';
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import zh_TW from 'vee-validate/dist/locale/zh_TW.json';
import companySerialNoChecker from '@/plugins/validate/companySerialNoChecker';
import mobilePhoneBarcode from '@/plugins/validate/mobilePhoneBarcode';
import naturalPersonCertificateBarcode from '@/plugins/validate/naturalPersonCertificateBarcode';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
localize('zh_TW', zh_TW);

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
  extend('password', {
    params: ['target'],
    validate(value, { target }) {
      return value === target;
    },
    message: '兩次輸入不一致'
  });
  extend('companySerialNoChecker', {
    validate: companySerialNoChecker,
    message: '統一編號不符合規範'
  });
  extend('mobilePhoneBarcode', {
    validate: mobilePhoneBarcode,
    message: '手機條碼格式錯誤'
  });
  extend('naturalPersonCertificateBarcode', {
    validate: naturalPersonCertificateBarcode,
    message: '自然人憑證條碼格式錯誤'
  });
});
